import React from 'react';

import { Outlet } from 'react-router';

import { PageLayout } from 'src/components/common';
import { EmployersDetailLayout } from 'src/layouts/EmployersDetailLayout';

export const EmployersDetailOutlet: React.FC = () => {
  return (
    <PageLayout titleContent="Employer Details" paperSx={{ mt: 5 }}>
      <EmployersDetailLayout>
        <Outlet />
      </EmployersDetailLayout>
    </PageLayout>
  );
};
